import React from "react";

import Backdrop from "./Backdrop";

import styled from "styled-components";

const Spinner = styled.div`
  width: 50%;
  height: 90vh;
  padding: 10%;
  position: fixed;
  z-index: 7000;
  box-sizing: border-box;
  padding: 10px;
  top: 5%;
  left: calc(24%);
  background: white;
  border-radius: 5px;
  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    top: 0%;
    left: calc(0%);
    border-radius: 0px;
  }
`;
const productViewModal = (props) => (
  <div>
    <Backdrop clicked={props.closeModal} show={props.show} />
    <Spinner
      style={{
        transform: props.show ? "translateY(0)" : "translateY(-100vh)",
        opacity: props.show ? "1" : "0",
      }}
    >
      {props.children}
    </Spinner>
  </div>
);

export default productViewModal;
